export default __webpack_public_path__ + "static/media/item-1.79e5bd45.webp";